import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import {
  JuouProTable,
  JuouProTableColumn,
  JuouProTableData,
  JuouProTableFilter,
  JuouProTableGetDataFunction,
  JuouDangerDialog,
  JuouProForm,
  JuouProFormItem,
  useBaseAsync,
} from 'juou-managebase-ui';
import { useApi } from '@/hooks/useApi';
import { ElMessage } from 'element-plus';
import { ref, watchEffect } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'colldevice',
  setup(__props, { expose: __expose }) {

const storeDeviceId = ref<number>();
const visible = ref(false);

const columns = ref<JuouProTableColumn[]>([]);
const tableRef = ref<InstanceType<typeof JuouProTable>>();
const addInitValue = {

};
const conditionsInitValue = {
};


const init = useBaseAsync(() => {
  columns.value = [
    {
      name: 'deviceIdHex',
      label: '设备序列号',
      type: 'string',
      rule: [{ required: true }],
    },

  ];
});


const operates: any[] = [];

const loading = ref(false);


const getData = useBaseAsync<JuouProTableGetDataFunction>(async(filter: JuouProTableFilter) => {
  if (!storeDeviceId.value) {
    return {
      total: 0,
      data: [],
    };
  }
  try {
    loading.value = true;
    const res = await useApi().storeDeviceApi.listStoreDeviceCollDeviceStoreDevice(storeDeviceId.value);
    const tableData: JuouProTableData = {
      total: res.data.data?.length || 0,
      data: res.data.data?.map((item: any) => ({
        deviceIdHex: item,
      })) || [],
    };
    return tableData;
  } finally {
    loading.value = false;
  }
});

const formatDeleteInfo = (row: any) => `您正在进行删除(${row.deviceIdHex})操作，请谨慎操作`;


const addFun = useBaseAsync(async(data: any) => {
  if (!storeDeviceId.value) {
    ElMessage.error('请选择一个门店设备');
    return;
  }
  await useApi().storeDeviceApi.addStoreDeviceCollDeviceStoreDevice({
    storeDeviceId: storeDeviceId.value,
    deviceIdHex: data.deviceIdHex,
  });
  ElMessage.success('添加成功');
});

const deleteFun = useBaseAsync(async(data: any) => {
  if (!storeDeviceId.value) {
    ElMessage.error('请选择一个门店设备');
    return;
  }
  await useApi().storeDeviceApi.delStoreDeviceCollDeviceStoreDevice(storeDeviceId.value, data.deviceIdHex);
  ElMessage.success('删除成功');
});


init();


__expose({
  show: (_storeDeviceId: number) => {
    storeDeviceId.value = _storeDeviceId;
    visible.value = true;
  },
});


return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    width: "600",
    title: "联动设备",
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
    draggable: ""
  }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createBlock(_unref(JuouProTable), {
            key: 0,
            ref_key: "tableRef",
            ref: tableRef,
            columns: columns.value,
            "get-data": _unref(getData),
            "on-add": _unref(addFun),
            "on-delete": _unref(deleteFun),
            loading: loading.value,
            "is-dangder-delete": true,
            "format-dangder-delete-info": formatDeleteInfo,
            "row-key": "id",
            operates: operates,
            "add-init-values": addInitValue,
            "codition-init-values": conditionsInitValue,
            "operation-width": 100
          }, null, 8, ["columns", "get-data", "on-add", "on-delete", "loading"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})